define('modules/integrations/view',['require','exports','module','views/BaseView','./companySelector/view','env','ldsh!./template'],function (require, exports, module) {
  'use strict';

  var BaseView = require('views/BaseView'),
      CompanySelectorView = require('./companySelector/view'),
      Config = require('env');

  var DEFAULT_INTEGRATION_SERVICE = 'zapier';

  var Layout = BaseView.extend({
    template: require('ldsh!./template'),

    beforeRender: function () {
      this.insertAccountSelector();
    },

    initialize: function () {
    },

    serialize: function () {
      return {
        me: this.me,
        activeTab: this.service || this.getDefaultService(),
        groupId: this.group.get('id'),
        baseUrl: '/integrations',
        zapierEnabled: Config.integrations.zapierEnabled,
        shopifyEnabled: Config.integrations.shopifyEnabled,
        APIsEnabled: Config.integrations.APIsEnabled,
      };
    },

    getDefaultService: function () {
      return DEFAULT_INTEGRATION_SERVICE;
    },

    insertAccountSelector: function () {
      this.insertView('#products-company-selector', new CompanySelectorView({
        me: this.me,
        group: this.group,
        products: this.products,
        serviceToRender: this.serviceToRender
      }));
    }
  });

  module.exports = Layout;
});

